import { ComponentFactoryResolver, Injectable, Type } from '@angular/core';

import { lazyMapComponents } from '../lazy-routes';

export type ModuleWithRoot = Type<any> & { rootComponent: Type<any> };

@Injectable({
    providedIn: 'root',
})
export class LazyRouteService {
    constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

    async loadAndRenderLazyComponents(data: any) {
        const { type } = data;
        const componentsMap = lazyMapComponents[type];
        if (componentsMap) {
            const component = await componentsMap.loadComponent();
            const factory = this.componentFactoryResolver.resolveComponentFactory(component);
            return factory;
        }
        return '';
    }
}
